import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import EyeLineIcon from "remixicon-react/EyeLineIcon";
import EyeOffLineIcon from "remixicon-react/EyeOffLineIcon";
import { useDispatch, useSelector } from "react-redux";
import Button from "../components/utils/Button";
import AuthActions from "../redux/auth/actions";
import Alert from "../components/utils/Alert";
import Long from "../../src/assets/images/USACANADA_LOGO.png";
// import { messaging } from '../helpers/firebase';
// import { getToken } from 'firebase/messaging';
import Style from "./Signin.module.css";

const { login, closeAlert, saveFcmToken, getAdminDetailes } = AuthActions;
const APP_BASEURL = process.env.REACT_APP_BASEURL;

function Signin() {
  const dispatch = useDispatch();
  const Auth = useSelector((state) => state.auth);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [passwordShow, setPasswordShow] = useState(false);

  useEffect(() => {
    dispatch(getAdminDetailes());
  }, []);

  useEffect(() => {
    if (Auth.loginMessage) {
      localStorage.setItem("mvno_admin_token", Auth.loginToken);
      window.location.href = "/";
    }
  }, [Auth.loginMessage]);

  const handleLogin = (data) => {
    dispatch(login(data));
    localStorage.setItem("user", "Address Fill");
  };

  const alertCancel = () => {
    dispatch(closeAlert());
  };

  return (
    <section className={Style.page}>
      <div className={Style.shell}>
        {/* Brand panel */}
        <div className={Style.brandPanel}>
          <div className={Style.logoBadge}>
            <img src={Long} alt="Logo" />
          </div>
          <div className={Style.brandCopy}>
            <p className={Style.brandEyebrow}>Admin console</p>
            <h2 className={Style.brandTitle}>
              Manage plans, subscribers,
              <br />
              and billing — all in one place.
            </h2>
          </div>
          <p className={Style.brandFooter}>
            © {new Date().getFullYear()} Chatr Portal
          </p>
        </div>

        {/* Form panel */}
        <div className={Style.formPanel}>
          <div className={Style.formHead}>
            <h1 className={Style.welcome}>Welcome back</h1>
            <p className={Style.subtext}>
              Sign in to your admin account to continue.
            </p>
          </div>

          {Auth.loginMessage ? (
            <Alert
              type="alert-success"
              text={Auth.loginMessage}
              closeBtn={alertCancel}
            />
          ) : (
            ""
          )}
          {Auth.loginError ? (
            <Alert
              type="alert-danger"
              text={Auth.loginError}
              closeBtn={alertCancel}
            />
          ) : (
            ""
          )}

          <form onSubmit={handleSubmit(handleLogin)}>
            <div className={Style.field}>
              <label className={Style.fieldLabel} htmlFor="username">
                Username
              </label>
              <div className={Style.inputWrap}>
                <input
                  id="username"
                  type="text"
                  className={`${Style.inputEl} ${errors.username ? Style.inputElError : ""}`}
                  name="username"
                  {...register("username", { required: true })}
                  placeholder="Enter username"
                />
              </div>
              {errors.username && errors.username.type === "required" ? (
                <p className={Style.errorText}>Username is required</p>
              ) : (
                ""
              )}
            </div>

            <div className={Style.field}>
              <label className={Style.fieldLabel} htmlFor="password">
                Password
              </label>
              <div className={Style.inputWrap}>
                <input
                  id="password"
                  type={passwordShow ? "text" : "password"}
                  className={`${Style.inputEl} ${errors.password ? Style.inputElError : ""}`}
                  name="password"
                  {...register("password", { required: true })}
                  placeholder="Enter password"
                  style={{ paddingRight: "44px" }}
                />
                <span className={Style.eyeToggle}>
                  {passwordShow ? (
                    <EyeLineIcon
                      size="1.1em"
                      onClick={() => setPasswordShow((pre) => !pre)}
                    />
                  ) : (
                    <EyeOffLineIcon
                      size="1.1em"
                      onClick={() => setPasswordShow((pre) => !pre)}
                    />
                  )}
                </span>
              </div>
              {errors.password && errors.password.type === "required" ? (
                <p className={Style.errorText}>Password is required</p>
              ) : (
                ""
              )}
            </div>

            {/* <div className={Style.rowBetween}>
              <Link to="/forget-password" className={Style.forgotLink}>
                Forgot password?
              </Link>
            </div> */}

            <div className={Style.submitRow}>
              <Button
                title="Sign in"
                buttonClass={Style.submitBtn}
                loading={Auth.loginLoading || Auth.fcmSaveLoading}
                buttonType="submit"
              />
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Signin;
